<template>
  <div>
    <input
      ref="file-input"
      class="file-input"
      type="file"
      :accept="acceptComputed"
      @change="handleClick"
    />
    <div
      :class="dragAreaClass"
      class="drop"
      @dragend="handleLeave"
      @dragleave="handleLeave"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      @click="handleUpload"
    >
      <slot>
        <div class="pa-4 text-center py-8">
          {{
            $vuetify.lang.t(
              "$vuetify.learnerManagement.importUsersDialog.dragFile"
            )
          }}
        </div>
      </slot>
      <!--<el-button :loading="loading" class="full" size="mini" type="primary" >
        Browse
      </el-button>-->
    </div>
  </div>
</template>

<script>
export default {
  props: ["accept", "asDataUrl"],
  data() {
    return {
      loading: false,
      file: null,
      dragAreaClass: [],
    };
  },
  computed: {
    acceptComputed() {
      return "*";
    },
    asDataUrlComputed() {
      if (this.asDataUrl === true) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error("Only support uploading one file!");
        this.file = null;
        this.onFileEmpty();
        return;
      } else {
        this.file = files[0]; // only use files[0]
        this.sendFile();
      }
      this.dragAreaClass = [];
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      this.dragAreaClass = ["light-green", "lighten-4"];
    },
    handleUpload() {
      this.$refs['file-input'].click()
    },
    handleLeave() {
      this.dragAreaClass = [];
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (files.length !== 1) {
        this.file = null;
        this.onFileEmpty();
        this.$message.error("Only support uploading one file!");
        return;
      } else {
        this.file = files[0];
        this.sendFile();
      }
    },
    sendFile() {
      if (this.asDataUrlComputed === true) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.$emit("onFileChoose", {
            file: this.file,
            dataUrl: event.target.result,
          });
        };
        reader.readAsDataURL(this.file);
      } else {
        this.$emit("onFileChoose", {
          file: this.file,
        });
      }
    },
    onFileEmpty() {
      this.$emit("onFileEmpty");
    },
  },
};
</script>

<style scoped lang="scss">
.file-input {
  display: none;
  z-index: -9999;
}
.drop {
  border: 4px dashed #bbb;
  width: 100%;
  /* height: 180px;
  line-height: 160px; */
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;

  &.over{
      background: #7bff8d;
  }
}
</style>